import { Box } from '@chakra-ui/layout'
import { Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'
import type { AnalyticsAPIResponse } from '../../interfaces'
import ScrollableTable from './ScrollableTable'

interface Props {
  data: AnalyticsAPIResponse
}

const TopIPAddressesTable = ({ data }: Props): React.ReactElement => {
  const { t } = useTranslation()

  const ipAddressData = data.topIps

  if (!ipAddressData || !ipAddressData.length) {
    return (
      <Box marginTop="1rem">{t('no_data_available', 'No Data Available')}</Box>
    )
  }

  const tableRows = ipAddressData.map(item => {
    if (!item.name || !item.count) {
      return null
    }

    return (
      <Tr key={item.name}>
        <Td>{item.name}</Td>
        <Td>
          {`${numeral(item.count)
            .format('0.0 a')
            .toUpperCase()} requests (${numeral(item.bandwidth)
            .format('0.0 ib')
            .replace('i', '')})`}
        </Td>
      </Tr>
    )
  })

  return (
    <Box marginTop="1rem">
      <ScrollableTable>
        <Thead>
          <Tr>
            <Th>{t('ip_address', 'IP address')}</Th>
            <Th>{t('usage', 'Usage')}</Th>
          </Tr>
        </Thead>
        <Tbody>{tableRows}</Tbody>
      </ScrollableTable>
    </Box>
  )
}

export default TopIPAddressesTable
